import React from 'react'
import "./Modal.scss"

const Modal = (props) => {

    const { show, size, header, children, onClose, html } = props

    return (
        <>
        { show && 
            <div className='Modal' >
                <div className={`modal-container  ${size}`}>
                    <div className={`modal-content`}>
                        { onClose && <span className="modal-close" onClick={onClose}>x</span> }
                        { header && <h1>{header}</h1>}
                        { html && <div className='modal-html'  dangerouslySetInnerHTML={html} /> }


                        { children || <></> }
                    {/* 
                        {content}
                        {children || <></>}
                        {showContinue && <div className="modal-actions">
                            {leftActionButtonCaption !== "" &&
                            <div className={`modal-actionbutton ${disableLeft === true ? 'disabled' : ''}`}
                                 onClick={onLeftActionButtonClick}>
                                {leftActionButtonCaption}
                            </div>
                        }
                        <div className={`modal-actionbutton ${disableRight === true ? 'disabled' : ''}`}
                              onClick={() => {
                            if (onContinueClick) {
                                onContinueClick()
                            }
                        }}>
                            {continueCaption || 'CLOSE'}
                        </div>
                      </div>}
                     */}
                    </div>
                </div>
            </div>
        }
        </>
    )

}

export default Modal;
